import { DOCS_FORM_NAMES, PREDICAMENT_STATE_YES } from "core/consts";
import { getGKVGeneralFormSchema } from "core/schemas/GKVGeneralFormSchema";
import { importAuctionToGKVGeneralForm } from "dsl/ecosystems/PatientForms/RehabForms/GKVGeneralForm/importAuction";
import { FormFieldConfigFactory } from "..";
import { GKVGeneralFormSections } from "./sections";

export const getGKVGeneralFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.GKV_GENERAL
> = ({ skipRequiredValidation, translations }) => {
  return {
    auctionToForm: importAuctionToGKVGeneralForm,
    config: { canPrint: true, canSendToHis: true },
    getInitialValue: ({ patient, value }) => {
      return {
        case_id: value?.case_id ?? "",
        communication_in_german_possible:
          value?.communication_in_german_possible ?? null,
        communication_other_language: value?.communication_other_language ?? "",
        data_transfer_consent_given: value?.data_transfer_consent_given ?? null,
        declaration_of_intent_confirmed:
          value?.declaration_of_intent_confirmed === PREDICAMENT_STATE_YES
            ? [PREDICAMENT_STATE_YES]
            : null,
        domestic_situation_is_safe: value?.domestic_situation_is_safe ?? null,
        general_practitioner_city: value?.general_practitioner_city ?? "",
        general_practitioner_contact_details:
          value?.general_practitioner_contact_details ?? "",
        general_practitioner_first_name:
          value?.general_practitioner_first_name ?? "",
        general_practitioner_honorific_prefix:
          value?.general_practitioner_honorific_prefix ?? "",
        general_practitioner_honorific_suffix:
          value?.general_practitioner_honorific_suffix ?? "",
        general_practitioner_housenumber:
          value?.general_practitioner_housenumber ?? "",
        general_practitioner_job_title:
          value?.general_practitioner_job_title ?? "",
        general_practitioner_last_name:
          value?.general_practitioner_last_name ?? "",
        general_practitioner_name: value?.general_practitioner_name ?? "",
        general_practitioner_phone_number:
          value?.general_practitioner_phone_number ?? "",
        general_practitioner_street: value?.general_practitioner_street ?? "",
        general_practitioner_zipcode: value?.general_practitioner_zipcode ?? "",
        hospital_ik_number:
          value?.hospital_ik_number ??
          patient.careseeker?.company?.ik_numbers?.[0]?.toString() ??
          null,
        insurance_ik_number:
          value?.insurance_ik_number ??
          patient.profile?.financing?.insurance?.ik_number?.toString() ??
          null,
        insurance_number: value?.insurance_number ?? "",
        insured_details_application_insurance_benefits:
          value?.insured_details_application_insurance_benefits ?? null,
        insured_details_guardian_1_city:
          value?.insured_details_guardian_1_city ?? "",
        insured_details_guardian_1_first_name:
          value?.insured_details_guardian_1_first_name ?? "",
        insured_details_guardian_1_house_number:
          value?.insured_details_guardian_1_house_number ?? "",
        insured_details_guardian_1_last_name:
          value?.insured_details_guardian_1_last_name ?? "",
        insured_details_guardian_1_phone:
          value?.insured_details_guardian_1_phone ?? "",
        insured_details_guardian_1_street:
          value?.insured_details_guardian_1_street ?? "",
        insured_details_guardian_1_type:
          value?.insured_details_guardian_1_type ?? null,
        insured_details_guardian_1_zipcode:
          value?.insured_details_guardian_1_zipcode ?? "",
        insured_details_guardian_2_city:
          value?.insured_details_guardian_2_city ?? "",
        insured_details_guardian_2_first_name:
          value?.insured_details_guardian_2_first_name ?? "",
        insured_details_guardian_2_house_number:
          value?.insured_details_guardian_2_house_number ?? "",
        insured_details_guardian_2_last_name:
          value?.insured_details_guardian_2_last_name ?? "",
        insured_details_guardian_2_phone:
          value?.insured_details_guardian_2_phone ?? "",
        insured_details_guardian_2_street:
          value?.insured_details_guardian_2_street ?? "",
        insured_details_guardian_2_type:
          value?.insured_details_guardian_2_type ?? null,
        insured_details_guardian_2_zipcode:
          value?.insured_details_guardian_2_zipcode ?? "",
        living_lift: value?.living_lift ?? null,
        living_lift_description: value?.living_lift_description ?? "",
        living_situation: value?.living_situation ?? null,
        living_situation_at_home: value?.living_situation_at_home ?? null,
        living_special: value?.living_special ?? "",
        patient_birthdate: value?.patient_birthdate ?? null,
        patient_city: value?.patient_city ?? "",
        patient_first_name: value?.patient_first_name ?? "",
        patient_housenumber: value?.patient_housenumber ?? "",
        patient_last_name: value?.patient_last_name ?? "",
        patient_phone_number: value?.patient_phone_number ?? "",
        patient_street: value?.patient_street ?? "",
        patient_zipcode: value?.patient_zipcode ?? "",
        prefered_clinic_city: value?.prefered_clinic_city ?? "",
        prefered_clinic_contacted: value?.prefered_clinic_contacted ?? null,
        prefered_clinic_contacted_start_date:
          value?.prefered_clinic_contacted_start_date ?? null,
        prefered_clinic_house_number: value?.prefered_clinic_house_number ?? "",
        prefered_clinic_name: value?.prefered_clinic_name ?? "",
        prefered_clinic_phone: value?.prefered_clinic_phone ?? "",
        prefered_clinic_postal_code: value?.prefered_clinic_postal_code ?? "",
        prefered_clinic_street: value?.prefered_clinic_street ?? "",
        reason_for_reha_clinic: value?.reason_for_reha_clinic ?? "",
        retirement_earning_capacity_company:
          value?.retirement_earning_capacity_company ?? "",
        retirement_pension_applied: value?.retirement_pension_applied ?? null,
        retirement_pension_company: value?.retirement_pension_company ?? "",
        retirement_pension_earning_capacity_applied:
          value?.retirement_pension_earning_capacity_applied ?? null,
        site_id_number:
          value?.site_id_number ?? patient.careseeker?.site_id_number ?? "",
        social_worker_fax_number: value?.social_worker_fax_number ?? "",
        social_worker_first_name: value?.social_worker_first_name ?? "",
        social_worker_last_name: value?.social_worker_last_name ?? "",
        social_worker_phone_number: value?.social_worker_phone_number ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.splitView.header.titleGkvForm,
    schema: getGKVGeneralFormSchema({
      isRedesignActive: true,
      skipRequiredValidation,
      translations,
    }),
    sections: GKVGeneralFormSections,
  };
};
